import {
    Divider,
    Grid,
    GridColumn, Icon, Label, List, ListItem, Popup,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow
} from "semantic-ui-react";
import * as React from "react";
import { LandfillSiteProject, UsageProject } from "../../../stores/project/project";
import "./area-data-landfill-site.css"
import { Link } from "react-router-dom";
import { useState } from "react";
import SVG from "react-inlinesvg";
import editIcon from "../../../assets/images/icons/plain/pencil.svg";
import collapseIcon from "../../../assets/images/icons/plain/navigate_open.svg";
import expandIcon from "../../../assets/images/icons/plain/navigate_close.svg";
import { AppState } from "../../../stores/app-mobx";
import locateIcon from "../../../assets/images/icons/plain/map_location2.svg";
import { Constants } from "../../../globals/constants";
import TruncatedText from "../../../components/truncated-text/truncated-text";
import { toLocaleString } from "../../../globals/functions";
import DescribedLabel from "../../../components/described-label/described-label";
import { getDesc, getLabel } from "../../../reflection/reflection";
import { UsageArea } from "../../../stores/area/area";

export default function AreaDataLandfillSite({
                                                 project,
                                                 appStore
                                             }: { project: LandfillSiteProject, appStore: AppState }): JSX.Element {
    function expandOrCollapseArea(areaId: number) {
        if (expandedArea === areaId) {
            setExpandedArea(undefined);
        } else {
            setExpandedArea(areaId);
        }
    }

    const [expandedArea, setExpandedArea] = useState<number | undefined>(undefined);

    const usageAreaRows: any[] = [];

    for (const a of project.areas) {
        usageAreaRows.push(
            <TableRow key={a.id}>
                <TableCell>
                    <span onClick={() => {
                        appStore.setAreaId(a.project.categoryKey, a.projectId, a.id);
                        window.scrollTo({ top: 0, behavior: "instant" });
                    }}>
                        <SVG src={locateIcon}
                             height="auto" width={20}
                             title="Fokus"/>
                    </span>
                </TableCell>
                <TableCell textAlign="right">{a.id}</TableCell>
                <TableCell textAlign="right">{a.areaNEK2?.toLocaleString() ?? 0}</TableCell>
                <TableCell textAlign="right">{a.areaNEK3?.toLocaleString() ?? 0}</TableCell>
                <TableCell textAlign="right">{a.areaNEK4?.toLocaleString() ?? 0}</TableCell>
                <TableCell textAlign="right">{a.areaNEK5?.toLocaleString() ?? 0}</TableCell>
                <TableCell textAlign="right">{a.areaNEK6?.toLocaleString() ?? 0}</TableCell>
                <TableCell textAlign="right">{a.areaNEKUnknown?.toLocaleString() ?? 0}</TableCell>
                <TableCell textAlign="right">{a.eligibilityDisplayText}</TableCell>
                <TableCell textAlign="right">{a.effectiveAreaRounded.toLocaleString()}</TableCell>
            </TableRow>
        );
    }

    const creationAreaRows: any[] = [];

    for (const a of project.recultivationProject.areas) {
        creationAreaRows.push(
            <TableRow key={a.id} onClick={() => expandOrCollapseArea(a.id)}>
                <TableCell>
                    {expandedArea === a.id ?
                        <SVG src={collapseIcon} height="auto" width={15} title="Zuklappen"/> :
                        <SVG src={expandIcon} height="auto" width={15} title="Aufklappen"/>}
                </TableCell>
                <TableCell textAlign="right">{a.id}</TableCell>
                <TableCell textAlign="right">{a.nek === 2 ? a.areaRounded.toLocaleString() : 0}</TableCell>
                <TableCell textAlign="right">{a.nek === 3 ? a.areaRounded.toLocaleString() : 0}</TableCell>
                <TableCell textAlign="right">{a.nek === 4 ? a.areaRounded.toLocaleString() : 0}</TableCell>
                <TableCell textAlign="right">{a.nek === 5 ? a.areaRounded.toLocaleString() : 0}</TableCell>
                <TableCell textAlign="right">{a.nek === 6 ? a.areaRounded.toLocaleString() : 0}</TableCell>
                <TableCell textAlign="right">{a.nek === 99 ? a.areaRounded.toLocaleString() : 0}</TableCell>
                <TableCell textAlign="right">{a.eligibilityDisplayText}</TableCell>
                <TableCell textAlign="right">{a.effectiveAreaRounded.toLocaleString()}</TableCell>
            </TableRow>
        );

        if (a.id === expandedArea) {
            creationAreaRows.push(
                <TableRow key={-1}>
                    <TableCell colSpan={10}>
                        <div className="areaData">
                            <div>
                                <span onClick={() => {
                                    appStore.setAreaId(a.project.categoryKey, a.projectId, a.id);
                                    window.scrollTo({ top: 0, behavior: "instant" });
                                }}>
                                    <SVG src={locateIcon}
                                         height="auto" width={20}
                                         title="Fokus"/>
                                </span>
                                <Link to={`flaechen/${Constants.projectCategoryCreation}/${a.id}/aendern`}
                                      preventScrollReset={true}>
                                    <SVG src={editIcon} height="auto" width={20} title="Fläche editieren"/>
                                </Link>
                            </div>
                            <List>
                                <ListItem>
                                    <DescribedLabel label={getLabel(a, "stage")} desc={getDesc(a, "stage")}/>: {a.stage}
                                </ListItem>
                                <ListItem>
                                    <DescribedLabel label={getLabel(a, "pngDisplayText")}
                                                    desc={getDesc(a, "pngDisplayText")}/>: {a.pngDisplayText}
                                </ListItem>
                                <ListItem>
                                    <DescribedLabel label={getLabel(a, "nek")} desc={getDesc(a, "nek")}/>: {a.nek}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "eligibilityDisplayText")}: {a.eligibilityDisplayText}
                                </ListItem>
                            </List>
                            <List>
                                <ListItem>
                                    {getLabel(a, "creationStatus")}: {a.creationStatus}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "soilWorkStartDateDisplayText")}: {a.soilWorkStartDateDisplayText}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "soilWorkEndDateDisplayText")}: {a.soilWorkEndDateDisplayText}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "afterSoilApplicationAcceptanceDateDisplayText")}: {a.afterSoilApplicationAcceptanceDateDisplayText}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "cultivationEndDateDisplayText")}: {a.cultivationEndDateDisplayText}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "afterCultivationAcceptanceDateDisplayText")}: {a.afterCultivationAcceptanceDateDisplayText}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "remarksProjectStatus")}: <TruncatedText
                                    text={a.remarksProjectStatus}/>
                                </ListItem>
                                <ListItem>
                                    <DescribedLabel label={getLabel(a, "afterSoilApplicationDocStatus")}
                                                    desc={getDesc(a, "afterSoilApplicationDocStatus")}/>: {a.afterSoilApplicationDocStatus}
                                </ListItem>
                                <ListItem>
                                    <DescribedLabel label={getLabel(a, "afterSoilApplicationDocSource")}
                                                    desc={getDesc(a, "afterSoilApplicationDocSource")}/>: {a.afterSoilApplicationDocSource}
                                </ListItem>
                                <ListItem>
                                    <DescribedLabel label={getLabel(a, "afterCultivationDocStatus")}
                                                    desc={getDesc(a, "afterCultivationDocStatus")}/>: {a.afterCultivationDocStatus}
                                </ListItem>
                                <ListItem>
                                    <DescribedLabel label={getLabel(a, "afterCultivationDocSource")}
                                                    desc={getDesc(a, "afterCultivationDocSource")}/>: {a.afterCultivationDocSource}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "remarksDocumentation")}: <TruncatedText
                                    text={a.remarksDocumentation}/>
                                </ListItem>
                            </List>
                        </div>
                    </TableCell>
                </TableRow>
            );
        }
    }

    return (
        <div className="areaDataLandfillSite">
            <Grid columns={1}>
                <GridColumn>
                    <Table compact="very" basic="very" size="small" columns={10}>
                        <TableHeader>
                            <TableRow className="tableHeader">
                                <TableHeaderCell></TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "id")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK2")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK3")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK4")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK5")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK6")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEKUnknown")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "eligibilityDisplayText")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageProject.prototype, "totalEffectiveAreaUsed")}</TableHeaderCell>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {usageAreaRows}
                            <TableRow className="italic">
                                <TableCell>TOTAL Beanspruchung</TableCell>
                                <TableCell></TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek2.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek3.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek4.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek5.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek6.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNekUnknown.toLocaleString()}</TableCell>
                                <TableCell></TableCell>
                                <TableCell textAlign="right">{project.totalEffectiveAreaUsed.toLocaleString()}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    <br/>
                    <Table compact="very" basic="very" size="small" columns={10}>
                        <TableBody>
                            {creationAreaRows}
                            <TableRow className="italic">
                                <TableCell>TOTAL Neuschaffung</TableCell>
                                <TableCell></TableCell>
                                <TableCell
                                    textAlign="right">{project.recultivationProject.totalAreaNek2.toLocaleString()}</TableCell>
                                <TableCell
                                    textAlign="right">{project.recultivationProject.totalAreaNek3.toLocaleString()}</TableCell>
                                <TableCell
                                    textAlign="right">{project.recultivationProject.totalAreaNek4.toLocaleString()}</TableCell>
                                <TableCell
                                    textAlign="right">{project.recultivationProject.totalAreaNek5.toLocaleString()}</TableCell>
                                <TableCell
                                    textAlign="right">{project.recultivationProject.totalAreaNek6.toLocaleString()}</TableCell>
                                <TableCell
                                    textAlign="right">{project.recultivationProject.totalAreaNekUnknown.toLocaleString()}</TableCell>
                                <TableCell></TableCell>
                                <TableCell
                                    textAlign="right">{project.recultivationProject.totalEffectiveAreaCreated.toLocaleString()}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    <Popup content='Projekt-ID Rekultivierungsprojekt'
                           trigger={
                               <Label size="large" color="blue"><Icon
                                   name="linkify"/> {project.recultivationProject.id}</Label>
                           }/>
                    <br/>
                    <Divider/>
                    <Table className="tableWithNoBorder" compact="very" basic="very" size="small" columns={10}>
                        <TableBody>
                            <TableRow className="italic">
                                <TableCell>Gesamtbilanz</TableCell>
                                <TableCell></TableCell>
                                <TableCell
                                    textAlign="right">{toLocaleString(-(project.totalAreaNek2 - project.recultivationProject.totalAreaNek2))}
                                </TableCell>
                                <TableCell
                                    textAlign="right">{toLocaleString(-(project.totalAreaNek3 - project.recultivationProject.totalAreaNek3))}
                                </TableCell>
                                <TableCell
                                    textAlign="right">{toLocaleString(-(project.totalAreaNek4 - project.recultivationProject.totalAreaNek4))}
                                </TableCell>
                                <TableCell
                                    textAlign="right">{toLocaleString(-(project.totalAreaNek5 - project.recultivationProject.totalAreaNek5))}
                                </TableCell>
                                <TableCell
                                    textAlign="right">{toLocaleString(-(project.totalAreaNek6 - project.recultivationProject.totalAreaNek6))}
                                </TableCell>
                                <TableCell
                                    textAlign="right">{toLocaleString(-(project.totalAreaNekUnknown - project.recultivationProject.totalAreaNekUnknown))}
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell textAlign="right">
                                    {project.totalAreaToCompensate > 0
                                        ? <span
                                            style={{ color: "red" }}>{(-project.totalAreaToCompensate).toLocaleString()}</span>
                                        : project.totalAreaToCompensate === 0
                                            ? project.totalAreaToCompensate.toLocaleString()
                                            : <span
                                                style={{ color: "green" }}>{(-project.totalAreaToCompensate).toLocaleString()}</span>
                                    }
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </GridColumn>
            </Grid>
        </div>
    );
}